<div class="login-container">
  <img src="assets/images/logocosmos.svg" alt="Cosmos Logo" class="logo">
  
  <div class="buttons-container">
    <button appAutofocus mat-stroked-button (click)="loginWithRedirect()" class="button login">
      Log In
    </button>

    <div *ngIf="isAuthenticated$ | async" class="authenticated-section">
      <div class="countdown" *ngIf="(countdown$ | async) as countdown">
        <p *ngIf="countdown >= 0">Autenticado anteriormente.Redirigiendo en {{ countdown }} segundos...</p>
      </div>
      
      <button mat-stroked-button (click)="logout()" class="button logout">
        Log Out
      </button>
    </div>
  </div>
</div>
